import {
  parseEmailedSignIn,
  type EmailedSignIn,
} from "@shared/auth/emailed-sign-in-link";
import type { SignInLink, SignInLinkFlow } from "@convex/constants/signInLinkFlows";

export function readEmailedSignIn(flow?: SignInLinkFlow): EmailedSignIn | null {
  if (typeof window === "undefined") return null;
  const signIn = parseEmailedSignIn(window.location.hash);
  return !flow || signIn?.flow === flow ? signIn : null;
}

export function clearEmailedSignIn(): void {
  if (!parseEmailedSignIn(window.location.hash)) return;
  const { pathname, search } = window.location;
  window.history.replaceState(null, "", `${pathname}${search}`);
}

export function signInLinkHere(flow: SignInLinkFlow): SignInLink {
  return { returnPath: `${window.location.pathname}${window.location.search}`, flow };
}
